import React from "react";

/**
 * NO-Q Primary Button
 * Built with "Urban Butler" persona: Efficient, Tactile, and Bold.
 */
const PrimaryButton = ({
    children,
    onClick,
    type = "button",
    disabled = false,
    className = "",
}) => {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`inline-flex items-center justify-center px-6 py-3 font-body font-bold text-base whitespace-nowrap 
              bg-primary text-txt-main border-2 border-transparent rounded-noq-sm transition-all duration-200 ease-in-out
              hover:scale-[0.97] focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
              disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100
              ${className}
            `}
        >
            {children}
        </button>
    );
};

export default PrimaryButton;
